export const NUM_PAGINATION_RECORDS = 50;
export const JOB_LIFE_IN_DAYS = 30;
